// -- AJAX --------------------------------------------------------------------
export const AJAX_CALL_STARTED = 'AJAX_CALL_STARTED';
export const AJAX_CALL_ENDED = 'AJAX_CALL_ENDED';
export const AJAX_CALL_FAILED = 'AJAX_CALL_FAILED';


// -- AANVRAAG ----------------------------------------------------------------
export const AANVRAAG_LOADED = 'AANVRAAG_LOADED';
export const AANVRAAG_SAVED = 'AANVRAAG_SAVED';
export const AANVRAAG_CLEARED = 'AANVRAAG_CLEARED';
// -- MIJN DOSSIER ------------------------------------------------------------

export const MIJN_DOSSIER_LOADED = 'MIJN_DOSSIER_LOADED';
export const SCHADUWDOSSIER_LOADED = 'SCHADUWDOSSIER_LOADED';
export const SCHADUWDOSSIER_RESET = 'SCHADUWDOSSIER_RESET';

// -- PROJECT -----------------------------------------------------------------
export const PROJECT_LOADED = 'PROJECT_LOADED';
export const PROJECT_SAVED = 'PROJECT_SAVED';
export const INFRASTRUCTUREN_LOADED = 'INFRASTRUCTUREN_LOADED';
export const INFRASTRUCTUUR_VALIDATED = 'INFRASTRUCTUUR_VALIDATED';
export const INFRASTRUCTUUR_SAVED = "INFRASTRUCTUUR_SAVED";
export const INFRASTRUCTUUR_REMOVED = "INFRASTRUCTUUR_REMOVED";
export const PROJECT_UNLOADED = 'PROJECT_UNLOADED';

// -- MINIMALE EISEN PER DOSSIER ----------------------------------------------
export const MINIMALE_EISEN_PER_DOSSIER_LOADED = 'MINIMALE_EISEN_PER_DOSSIER_LOADED';
export const MINIMALE_EISEN_PER_DOSSIER_SAVED = 'MINIMALE_EISEN_PER_DOSSIER_SAVED';

// -- MINIMALE EISEN PER INFRASTRUCTUUR ---------------------------------------
export const MINIMALE_EISEN_PER_INFRASTRUCTUUR_LOADED = 'MINIMALE_EISEN_PER_INFRASTRUCTUUR_LOADED';
export const MINIMALE_EISEN_PER_INFRASTRUCTUUR_SAVED = 'MINIMALE_EISEN_PER_INFRASTRUCTUUR_SAVED';
export const MINIMALE_EISEN_PER_DOSSIER_GENERATE_RAPPORT = 'MINIMALE_EISEN_PER_DOSSIER_GENERATE_RAPPORT';

// -- BOVEN LOKALITEIT PER DOSSIER --------------------------------------------
export const BOVEN_LOKALITEIT_PER_DOSSIER_LOADED = 'BOVEN_LOKALITEIT_PER_DOSSIER_LOADED';
export const BOVEN_LOKALITEIT_PER_DOSSIER_SAVED = 'BOVEN_LOKALITEIT_PER_DOSSIER_SAVED';

// -- BOVEN LOKALITEIT PER INFRASTRUCTUUR -------------------------------------
export const BOVEN_LOKALITEIT_PER_INFRASTRUCTUUR_LOADED = 'BOVEN_LOKALITEIT_PER_INFRASTRUCTUUR_LOADED';
export const BOVEN_LOKALITEIT_PER_INFRASTRUCTUUR_SAVED = 'BOVEN_LOKALITEIT_PER_INFRASTRUCTUUR_SAVED';
export const BOVEN_LOKALITEIT_PER_INFRASTRUCTUUR_CACHE_SAVED = 'BOVEN_LOKALITEIT_PER_INFRASTRUCTUUR_CACHE_SAVED';
export const BOVEN_LOKALITEIT_PER_INFRASTRUCTUUR_VALIDATED = 'BOVEN_LOKALITEIT_PER_INFRASTRUCTUUR_VALIDATED';
export const BOVEN_LOKALITEIT_UNLOADED = 'BOVENLOKALITEIT_UNLOADED';

// -- CRITERIA BOVEN LOKAAL -------------------------------------
export const CRITERIA_BOVEN_LOKAAL_LOADED = 'CRITERIA_BOVEN_LOKAAL_LOADED';
export const CRITERIA_BOVEN_LOKAAL_SAVED = 'CRITERIA_BOVEN_LOKAAL_SAVED';
// -- CRITERIA TOPSPORT -------------------------------------
export const CRITERIA_TOPSPORT_LOADED = 'CRITERIA_TOPSPORT_LOADED';
export const CRITERIA_TOPSPORT_SAVED = 'CRITERIA_TOPSPORT_SAVED';

export const GEWICHTBL_LOADED = 'GEWICHTBL_LOADED';


// -- INFRASTRUCTUREN ---------------------------------------------------------
export const INFRASTRUCTUREN_BY_DOSSIER_LOADED = 'INFRASTRUCTUREN_BY_DOSSIER_LOADED';

// -- REFERENCES --------------------------------------------------------------
export const REFERENCES_LOADED = 'REFERENCES_LOADED';

// -- INDIENEN ----------------------------------------------------------------
export const INDIENEN_LOADED = 'INDIENEN_LOADED';
export const INDIENEN_SAVED = 'INDIENEN_SAVED';

// -- SIMULATIEDOSSIER ----------------------------------------------------------------
export const SIMULATIEDOSSIER_LOADED = 'SIMULATIEDOSSIER_LOADED';
export const SIMULATIEINFRASTRUCTUREN_BY_DOSSIER_LOADED = 'SIMULATIEINFRASTRUCTUREN_BY_DOSSIER_LOADED';
export const SIMULATIEINFRASTRUCTUUR_SAVED = 'SIMULATIEINFRASTRUCTUUR_SAVED';
export const SIMULATIEINFRASTRUCTUUR_VALIDATED = 'SIMULATIEINFRASTRUCTUUR_VALIDATED';
export const SIMULATIEINFRASTRUCTUREN_LOADED = 'SIMULATIEINFRASTRUCTUREN_LOADED';
export const SIMULATIEINFRASTRUCTUUR_REMOVED = 'SIMULATIEINFRASTRUCTUUR_REMOVED';
export const SIMULATIE_PER_INFRASTRUCTUUR_CACHE_SAVED = 'SIMULATIE_PER_INFRASTRUCTUUR_CACHE_SAVED';
export const SIMULATIE_PER_INFRASTRUCTUUR_VALIDATED = 'SIMULATIE_PER_INFRASTRUCTUUR_VALIDATED';

export const ACTIVE_ACTIVETOPNAVITEMID_UPDATED = 'ACTIVE_ACTIVETOPNAVITEMID_UPDATED';
export const LAYOUT_UPDATED = 'LAYOUT_UPDATED';
export const VOORTGANGSRAPPORT_LOADED = 'VOORTGANGSRAPPORT_LOADED';

export const ADD_ERROR = 'ADD_ERROR';
export const CLEAR_ERRORS = 'CLEAR_ERRORS';

export const THROW_EXCEPTION = 'THROW_EXCEPTION';
export const CLEAR_EXCEPTION = 'CLEAR_EXCEPTION';

export const READ_SETTINGS_SUCCESS = 'READ_SETTINGS_SUCCESS';

export const BEADS_LOADED = 'BEADS_LOADED';
export const VOORTGANGSRAPPORT_BEADS_LOADED = 'VOORTGANGSRAPPORT_BEADS_LOADED';